export const baseUrl = `https://ej-projects.vercel.app/api/web`;

export const requestsData = [
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "gnanam_engineering_banners" } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "gnanam_engineering_services_categories" } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "gnanam_engineering_blogs" } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "gnanam_engineering_testimonials" } },
    { url: `${baseUrl}`, method: 'post', payload: { moduleName: "gnanam_engineering_clients" } },
];